import React from 'react';
import {Route, Switch} from "react-router";
import HomeRoute from "./HomeRoute";
import LoginPage from "../components/login/LoginPage";
import ProductsList from "../components/productsList/ProductsList";
import SinglePage from "../components/singlePage/SinglePage";
import ComparisonPage from "../components/comparisonPage/ComparisonPage";
import CartPage from "../components/buySteps/cartPage/CartPage";
import FinalApproval from "../components/buySteps/finalApproval/FinalApproval";
import CompleteInformation from "../components/buySteps/infoUser/CompleteInformation";
import SendProduct from "../components/buySteps/productDelivery/SendProduct";
import SuccessPage from "../components/buySteps/successPage/SuccessPage";
import ErrorPage from "../components/buySteps/errorPage/ErrorPage";
import Counter from "../components/profile/counter/Counter";
import Orders from "../components/profile/oreders/Orders";
import OrderDetails from "../components/profile/oreders/orderDetails/OrderDetails";
import Address from "../components/profile/address/Address";
import Comments from "../components/profile/comments/Comments";
import EmailProfile from "../components/profile/email/EmailProfile";
import SpecialOffer from "../components/discount_bundle_page/specialOfferPage/SpecialOffer";
import BundlesPage from "../components/discount_bundle_page/bundlesPage/BundlesPage";
import SingleBundlePage from "../components/discount_bundle_page/singleBundlePage/SingleBundlePage";
import BrandPage from "../components/brandPage/BrandPage";
import VendorHomePage from "../components/vendorPage/ vendorHomePage/VendorHomePage";
import VendorLogin from "../components/vendorPage/vendorLogin/VendorLogin";
import VendorLoginCode from "../components/vendorPage/vendorLoginCode/VendorLoginCode";
import VendorInformation from "../components/vendorPage/vendorInformation/VendorInformation";
import VendorUploadFile from "../components/vendorPage/vendorUploadFile/VendorUploadFile";
import SuccessLoginVendor from "../components/vendorPage/SuccessLoginVendor";
import HomePageSkeleton from "../skeletonLoading/HomePageSkeleton";
import SkeletonProducts from "../skeletonLoading/SkeletonProducts";
import SkeletonSingleProduct from "../skeletonLoading/SkeletonSingleProduct";
import AddressUrl from "../components/Address/AddressUrl";


const App = () => {
    return (
        <div id="home-page-wrapper">
            <div
                className="animate__animated animate__fadeOut animate__faster bg-modal-wrapper bg-modal-wrapper-menu-products"
                id="bg-modal-wrapper-menu"/>
            <div className="position-relative">
                <Switch>
                    <Route path="/login" component={LoginPage}/>
                    <Route path="/products" component={ProductsList}/>
                    <Route path="/comparisonPage" component={ComparisonPage}/>
                    <Route path="/singlePage" component={SinglePage}/>
                    <Route path="/cartPage" component={CartPage}/>
                    <Route path="/finalApproval" component={FinalApproval}/>
                    <Route path="/infoUser" component={CompleteInformation}/>
                    <Route path="/productDelivery" component={SendProduct}/>
                    <Route path="/success" component={SuccessPage}/>
                    <Route path="/error" component={ErrorPage}/>
                    <Route path="/counter" component={Counter}/>
                    <Route path="/orders" component={Orders}/>
                    <Route path="/orderDetails" component={OrderDetails}/>
                    <Route path="/address" component={Address}/>
                    <Route path="/commentsProfile" component={Comments}/>
                    <Route path="/emailProfile" component={EmailProfile}/>
                    <Route path="/bundlesPage" component={BundlesPage}/>
                    <Route path="/specialOfferPage" component={SpecialOffer}/>
                    <Route path="/singleBundlePage" component={SingleBundlePage}/>
                    <Route path="/brandPage" component={BrandPage}/>
                    <Route path="/vendorHomePage" component={VendorHomePage}/>
                    <Route path="/vendorLogin" component={VendorLogin}/>
                    <Route path="/vendorLoginCode" component={VendorLoginCode}/>
                    <Route path="/vendorInformation" component={VendorInformation}/>
                    <Route path="/vendorUploadFile" component={VendorUploadFile}/>
                    <Route path="/successLoginVendor" component={SuccessLoginVendor}/>
                    <Route path="/homePageSkeleton" component={HomePageSkeleton}/>
                    <Route path="/skeletonProducts" component={SkeletonProducts}/>
                    <Route path="/skeletonSingleProduct" component={SkeletonSingleProduct}/>
                    <Route path="/addressUrl" component={AddressUrl}/>
                    <Route path="/" exact component={HomeRoute}/>
                </Switch>
            </div>
        </div>
    );
};

export default App;
